var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSidebarTopRanking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99687 8.59581H12.4669C12.4358 8.83139 12.3859 9.06413 12.3179 9.29181C12.0386 10.2209 11.4676 11.0353 10.6893 11.6145C9.91109 12.1938 8.96701 12.507 7.99687 12.5078C5.62387 12.5078 3.48988 10.4798 3.48988 7.99981C3.48988 5.86581 4.84488 4.20981 6.70288 3.67381C6.93153 3.6081 7.16488 3.55996 7.40088 3.52981V7.99981C7.40088 8.32981 7.66687 8.59581 7.99687 8.59581ZM8.59287 2.89581C8.59314 2.81747 8.5779 2.73985 8.54805 2.66742C8.51819 2.59499 8.4743 2.52918 8.4189 2.47378C8.3635 2.41839 8.2977 2.3745 8.22527 2.34464C8.15284 2.31478 8.07522 2.29954 7.99687 2.29981C6.48571 2.30166 5.03697 2.90279 3.96841 3.97135C2.89986 5.0399 2.29873 6.48864 2.29688 7.99981C2.29688 11.1438 4.85487 13.6998 7.99687 13.6998C9.50796 13.6977 10.9565 13.0965 12.025 12.028C13.0935 10.9595 13.6948 9.51089 13.6969 7.99981C13.6963 7.8419 13.6334 7.69061 13.5217 7.57896C13.4101 7.4673 13.2588 7.40434 13.1009 7.40381H8.59287V2.89581Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 5.312V5.31C13.7474 4.49735 13.4226 3.7189 12.8469 3.14529C12.2713 2.57169 11.4917 2.24973 10.679 2.25C10.6227 2.24987 10.5669 2.26084 10.5149 2.28229C10.4629 2.30374 10.4156 2.33525 10.3757 2.37501C10.3359 2.41476 10.3042 2.46199 10.2827 2.51398C10.2611 2.56597 10.25 2.62171 10.25 2.678V5.32C10.25 5.556 10.44 5.75 10.679 5.75H13.321C13.3774 5.75013 13.4332 5.73913 13.4853 5.71761C13.5374 5.6961 13.5848 5.66451 13.6246 5.62464C13.6645 5.58478 13.6961 5.53744 13.7176 5.48533C13.7391 5.43322 13.7501 5.37738 13.75 5.321V5.312ZM11.109 4.894V3.23C11.596 3.308 12.023 3.503 12.337 3.859C12.5971 4.15215 12.7742 4.50946 12.85 4.894H11.109Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_162"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarTopRanking);
export default __webpack_public_path__ + "static/media/sidebar-top-ranking.a251097fe0dff3bad4715ac72780e6b1.svg";
export { ForwardRef as ReactComponent };